import React from 'react';

const PageWrapper = ({ children, topPadding }) => (
  <div style={{ minHeight: '50vh', color: 'var(--neutral--100)', padding: topPadding ? '2rem 2rem' : '0rem 1rem' }}>
    {children}
  </div>
);

export default PageWrapper;
